/**
 * Driver rate of pay (mirrors backend/utils/driverPay.js). 'full' = the whole job
 * amount, as before; 'percent' and 'flat' change what the weekly ACH run pays an
 * Org 1 driver. For an SP's drivers it is the company's own record.
 */
export const PAY_TYPES = [
  { value: 'full', label: 'Full job amount' },
  { value: 'percent', label: 'Percent of each job' },
  { value: 'flat', label: 'Flat amount per job' }
];

export const normalizeDriverPay = (p = {}) => ({
  type: ['full', 'percent', 'flat'].includes(p?.type) ? p.type : 'full',
  percent: Number.isFinite(Number(p?.percent)) ? Number(p.percent) : 100,
  flatAmount: Number.isFinite(Number(p?.flatAmount)) ? Number(p.flatAmount) : 0,
  note: p?.note || ''
});

export const describeDriverPay = (p) => {
  const d = normalizeDriverPay(p);
  if (d.type === 'percent') return `${d.percent}% of job`;
  if (d.type === 'flat') return `$${Number(d.flatAmount).toFixed(2)} per job`;
  return 'Full job amount';
};

/**
 * Whether the signed-in user may set this driver's rate. The server is the real
 * gate (it strips the field otherwise); this only decides whether to show the
 * controls enabled. `me` is the stored permissions object.
 */
export const canSetDriverPay = (me, target) => {
  if (!me || !target) return false;
  const admin = me.secondaryRoles?.admin === true;
  if (['OW', 'sOW', 'OWp', 'RM'].includes(me.primaryRole)) return true;
  if (me.primaryRole === 'SP' || admin) {
    const myVendor = me.vendorId || me.vendorNumber;
    return !!myVendor && (myVendor === target.vendorNumber || myVendor === target.vendorId);
  }
  return false;
};
